<section id="escheatment-page">
   <div
      class="spinner"
      *ngIf="mainLoading">
      <div
         class="spinner-border"
         role="status">
         <span class="sr-only">Loading...</span>
      </div>
   </div>
   <div
      class=""
      *ngIf="!mainLoading">
      <div class="viewport">
         <p-table
            #dt
            [value]="rows"
            [lazy]="true"
            (onLazyLoad)="pageRequested.next($event)"
            [loading]="tableLoading"
            [rows]="pageSize"
            [scrollable]="true"
            scrollHeight="flex"
            [virtualScroll]="true"
            [virtualRowHeight]="75"
            (onSort)="resetTable()">
            <ng-template pTemplate="colgroup">
               <colgroup>
                  <col style="width: 220px" />
                  <col style="width: 200px" />
                  <col style="width: 200px" />
                  <col style="width: 200px" />
                  <col style="width: 140px" />
                  <col style="width: 120px" />
                  <col style="width: 150px" />
                  <col style="min-width: 250px" />
               </colgroup>
            </ng-template>
            <ng-template pTemplate="header">
               <tr>
                  <th>
                     <p-select
                        required
                        appendTo="body"
                        name="practiceskey"
                        [options]="practices"
                        placeholder="Select practice"
                        optionLabel="nameId"
                        [(ngModel)]="selectedPractice"
                        (onChange)="onFilterPractice($event)"
                        styleClass="full-width-control"></p-select>
                  </th>
                  <th colspan="6"></th>
               </tr>
               <tr>
                  <th pSortableColumn="practiceName">
                     Practice Name
                     <p-sortIcon field="practiceName"></p-sortIcon>
                  </th>
                  <th pSortableColumn="origSourceSkey">
                     PIMS Client Id
                     <p-sortIcon field="origSourceSkey"></p-sortIcon>
                  </th>
                  <th pSortableColumn="firstName">
                     First Name
                     <p-sortIcon field="firstName"></p-sortIcon>
                  </th>
                  <th pSortableColumn="lastName">
                     Last Name
                     <p-sortIcon field="lastName"></p-sortIcon>
                  </th>
                  <th pSortableColumn="phone">
                     Phone
                     <p-sortIcon field="phone"></p-sortIcon>
                  </th>
                  <th pSortableColumn="balance">
                     Balance
                     <p-sortIcon field="balance"></p-sortIcon>
                  </th>
                  <th pSortableColumn="lastTransactionDate">
                     Last Transaction
                     <p-sortIcon field="lastTransactionDate"></p-sortIcon>
                  </th>
                  <th>Should we submit this money to the state as unclaimed property?</th>
               </tr>
            </ng-template>
            <ng-template
               pTemplate="body"
               let-item
               let-rowIndex="rowIndex">
               <tr style="height: 75px">
                  <td>{{ item.practiceName }}</td>
                  <td>{{ item.origSourceSkey }}</td>
                  <td>{{ item.firstName }}</td>
                  <td>{{ item.lastName }}</td>
                  <td>{{ item.phone | phone : "US" }}</td>
                  <td>{{ item.balance | currency }}</td>
                  <td>{{ item.lastTransactionDate | date }}</td>
                  <td>
                     <button
                        class="btn btn-primary"
                        title="Submit to State"
                        (click)="confirm(rowIndex, item, true)">
                        Submit to State
                     </button>
                     &nbsp;
                     <button
                        class="btn btn-secondary"
                        title="Do Not Submit"
                        (click)="confirm(rowIndex, item, false)">
                        Do Not Submit
                     </button>
                  </td>
               </tr>
            </ng-template>
         </p-table>
      </div>
   </div>
   <p-confirmDialog
      header="Confirmation"
      icon="pi pi-exclamation-triangle"></p-confirmDialog>
</section>
